import { render, staticRenderFns } from "./BaseContactListItem.vue?vue&type=template&id=5debaa9e&scoped=true&"
import script from "./BaseContactListItem.vue?vue&type=script&lang=js&"
export * from "./BaseContactListItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseContactListItem.vue?vue&type=style&index=0&id=5debaa9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5debaa9e",
  null
  
)

export default component.exports